import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'admin/sys/auth/login',
    method: 'post',
    data
  })
}

export function getCodeImg() {
  return request({
    url: 'admin/sys/auth/code',
    method: 'get'
  })
}

export function saveToken(data) {
  return request({
    url: 'admin/sys/auth/savetoken',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: 'admin/sys/auth/info',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: 'admin/sys/auth/logout',
    method: 'post'
  })
}

export function getRouters(data) {
  return request({
    url: 'admin/sys/auth/menus',
    method: 'post',
    data
  })
}

export function users(data) {
  return request({
    url: 'admin/sys/user',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: 'admin/sys/user',
    method: 'delete',
    data
  })
}

export function get(id) {
  return request({
    url: 'admin/sys/user/' + id,
    method: 'get'
  })
}

export function saveOrUpdate(data) {
  return request({
    url: 'admin/portal/user',
    method: 'put',
    data
  })
}

export function update(data) {
  return request({
    url: 'admin/sys/user/update',
    method: 'post',
    data
  })
}

export function enable(id, enable) {
  return request({
    url: 'admin/sys/user/enableUser/' + id + '/' + enable,
    method: 'post'
  })
}

export function treeUser() {
  return request({
    url: 'admin/sys/user/userTree',
    method: 'get'
  })
}

export function change(id) {
  return request({
    url: 'admin/sys/auth/change/' + id,
    method: 'get'
  })
}
// 企业用户
export function eulist(data) {
  return request({
    url: 'admin/sys/user/enterpriseUsers',
    method: 'post',
    data
  })
}

// 分页企业用户
export function companyUserlist(data) {
  return request({
    url: 'admin/portal/user/enterpriseList',
    method: 'post',
    data
  })
}

// 统计企业用户
export function getCompanyUsers(data) {
  return request({
    url: 'admin/sys/user/getCompanyUsers',
    method: 'post',
    data
  })
}